import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelpPageEvent } from '../../services/help.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'app-help-popup',
    templateUrl: './help-popup.component.html',
    imports: [MaterialModule]
})
export class HelpPopupComponent {

  safeUrl: SafeResourceUrl;

  private dialogRef = inject(MatDialogRef<HelpPopupComponent>);
  public data = inject<HelpPageEvent>(MAT_DIALOG_DATA);
  private sanitizer = inject(DomSanitizer);

  constructor() {

    this.dialogRef?.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.dialogRef.close();
      }
    });

    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }
}
